



































































































































































































































































































































import { mixins } from "vue-class-component";
import moment from "moment/moment";
import { Component } from "vue-property-decorator";
import { Site } from "@/shared/Site";
import MyMixin from "@/mixins/datemixin";
import MobileMixin from "@/mixins/mobileMixin";
import TicketMixin from "@/mixins/ticketsMixin";
import ExpandableDateChooser from "@/components/expansion/expandableDateChooser.vue";
import ExpandableListeSites from "@/components/expansion/expandableListeSites.vue";
import ExpandableCriteresRecus from "@/components/expansion/expandableCriteresRecus.vue";
import DateType from "@/shared/DateType";
import ErrorMixin from "@/mixins/errorMixins";
import VueJsonToCsv from "vue-json-to-csv";
import RecuUi from "@/ui-component/RecuUI.vue";
import NumberTmpl from "@/ui-component/number.vue";
import Recu from "@/shared/Recu";
import RecurrenceUtils from "@/utils/recurrenceUtils";

@Component({
  components: {
    ExpandableDateChooser,
    ExpandableListeSites,
    ExpandableCriteresRecus,
    VueJsonToCsv,
    NumberTmpl,
    RecuUi,
  },
})
export default class FeuilleCaisse extends mixins(
  MyMixin,
  MobileMixin,
  TicketMixin,
  ErrorMixin
) {
  public dateType: DateType = new DateType();
  public selectedSites: Site[] = [];
  public recus: any = [];
  public message: string = "";
  public withEcarts = false;

  public mesFiltres = [
    { libelle: "En attente", $selected: true, etat: "WAITING" },
    { libelle: "Manquant", $selected: true, etat: "MISSING" },
    { libelle: "Ecarts", $selected: false, etat: "ECART" },
    { libelle: "Validé", $selected: false, etat: "FORCED" },
    { libelle: "Cloturé", $selected: false, etat: "RECU_FIN_SESSION_DECLARE" },

    // {libelle: "Relancé directeur", $selected: false, etat: "DIRECTEUR"},
    // {libelle: "Relancé DM", $selected: false, etat: "DISTRICT"}
  ];

  public loadData: boolean = false;
  public loadTicket: boolean = false;
  public headers: any = [];

  public resumeData = {
    manquants: { nombre: 0, montant: 0 },
    valides: { nombre: 0, montant: 0 },
    enAttente: { nombre: 0, montant: 0 },
    clotures: { nombre: 0, montant: 0 },
    ecarts: { nombre: 0, montant: 0 },
  };

  public updatedSearchCrit: boolean = false;
  public selectedRecu: any = {};

  public filter: { [k: string]: any } = {
    start: moment().format("YYYY-MM-DD"),
    ent: moment().format("YYYY-MM-DD"),
  };

  public mounted() {
    this.updateDate(this.dateType);
    this.headers = this.generateHeaderFeuilleCaisse();
    this.updateParam(this.mesFiltres);
    const hier = moment().subtract("d", 1).toDate();
    this.dateType.dateDebut = hier;
    this.dateType.dateFin = hier;
    // this.filterByClient();
  }
  /*
   * methode permettant de verifier si l'on doit ou pas afficher une div
   * sur la liste de ticket permettant de rafraichir celle ci
   */
  public showTicketsLoad(forceFalse?: boolean) {
    if (forceFalse) {
      this.updatedSearchCrit = false;
      return false;
    } else {
      if (this.recus.length === 0) {
        return true;
      } else {
        if (this.updatedSearchCrit) {
          return true;
        }
      }
      return false;
    }
  }

  public closeLoad(evt: Event) {
    this.updatedSearchCrit = false;
    this.showTicketsLoad(true);
    evt.stopPropagation();
  }

  public recusFiltered() {
    let recus = new Array();
    if (this.withEcarts) {
      recus = this.recus.filter((recu: any) => {
        return recu.etat !== "MISSING" && Math.abs(recu.diff) >= 10;
      });
    } else {
      recus = this.recus;
    }
    // this.filteredRecus = recus;
    return recus;
  }

  public updateDate(date: DateType) {
    this.dateType = date;
    this.filter.start = moment(this.dateType.dateDebut).format("YYYY-MM-DD");
    this.filter.end = moment(this.dateType.dateFin).format("YYYY-MM-DD");
    this.updatedSearchCrit = true;
    this.message = this.$t("Update").toString();
  }

  public getMyClass(item: any) {
    let myclass = "";
    if (item && item.id === this.selectedRecu.id) {
      myclass += "ticketSelected";
    } else {
      myclass += "item";
    }
    // console.log(item);
    if (item.etat === "Manquant") {
      myclass += " orange  lighten-1";
    } else if (item.etat === "En attente") {
      myclass += " red darken-1";
    }

    return myclass;
  }
  /**
   * methode d'ajout d'un site
   */
  public addSite(site: Site) {
    if (
      this.selectedSites.length > 0 &&
      this.selectedSites[0].restaurantId === site.restaurantId
    ) {
      this.selectedSites = new Array();
      this.site = "";
    } else {
      this.selectedSites = [];
      this.selectedSites.push(site);
      this.site = site.libelle;
    }
    this.makeResume();
  }
  /**
   * mide a jour d'un parametre reaffichage du boutton rechercher
   */
  public updateParam(filtres: any) {
    this.mesFiltres = filtres;
    this.withEcarts = false;
    this.etat = "";

    filtres.map((filtre: any) => {
      if (
        filtre.$selected &&
        (filtre.etat === "WAITING" ||
          filtre.etat === "MISSING" ||
          filtre.etat === "FORCED" ||
          filtre.etat === "RECU_FIN_SESSION_DECLARE")
      ) {
        if (this.etat !== "") {
          this.etat += ",";
        }
        this.etat += filtre.libelle;
      } else if (filtre.$selected && filtre.etat === "ECART") {
        this.withEcarts = true;
      }
    });
    // console.log(this.etat);
  }
  /**
   * methode de récuperation des recus comptages caisse de (type 7 et 30) sur le serveur
   */
  public getRecus() {
    this.updatedSearchCrit = false;
    this.message = "";
    this.loadData = true;
    this.filter.userid = this.me.id;
    this.$store
      .dispatch("analyses/getRecusCaissesCentral", this.filter)
      .then(
        (liste: any) => {
          // console.log(liste);
          this.recus = liste;
          this.getManquants();
          // console.log(this.recus);
          if (this.recus.length === 0) {
            this.message = this.$t("NoTicketToCrit").toString();
          }
          this.orderData();
          this.makeResume();
          this.loadData = false;
        },
        (err: any) => {
          this.loadData = false;
          console.log(err);
          this.setError(err);
        }
      )
      .catch((error: any) => {
        this.loadData = false;
        console.log(error);
        this.setError(error);
      });
  }
  /*
   * méthode de récuperation d'un recu
   */
  public getRecu(recu: any) {
    // console.log(recu);
    this.selectedRecu = recu;
  }
  /**
   * contresignage d'un recu en écart
   * @param doc - le document à contresigner
   */
  public contreSigne(doc: any) {
    const signatureData = {
      restaurantId: doc.restaurantId,
      docId: doc.id,
      date: moment().format("YYYY-MM-DD"),
      managerCode: "-1",
      managerName: this.me.login,
      commentaire: doc.commentaire,
    };

    this.$store.dispatch("analyses/contreSigneDoc", signatureData).then(
      (response: any) => {
        // console.log(response);
        this.getRecus();
        this.selectedRecu = new Recu();
        RecurrenceUtils.relanceExport(
          signatureData.date,
          signatureData.restaurantId
        ).then((res: any) => {
          /* */
        });

        this.setSuccess(this.$t("RecuForced").toString());
      },
      (err: any) => {
        this.loadData = false;
        console.log(err);
        this.setError(err);
      }
    );
  }
  /**
   * relance mail aux DM
   * utilisé pour les manquant ou les ecarts à valider
   */
  public relanceDM() {
    console.log(this.selectedRecu);
    const recu = {
      role: "DM",
      id: this.selectedRecu.id,
      user: this.me.login,
      datefiscale: this.formatDateSend(this.selectedRecu.dateFicale),
      userId: this.me.id,
      site: this.selectedRecu.restaurantId,
    };
    if (this.selectedRecu.type === "MISSING") {
      // console.log("je suis manquant");
      this.relanceMailManquant(recu);
    } else {
      // console.log("je suis recu");
      this.relanceMailRecu(recu);
    }
  }
  /**
   * relance Mail d'un directeur
   * à date uniquement utilisé pour les manquants
   */
  public relanceDir() {
    // console.log(this.selectedRecu);
    const recu = {
      role: "directeur",
      user: this.me.login,
      datefiscale: this.formatDateSend(this.selectedRecu.dateFicale),
      userId: this.me.id,
      site: this.selectedRecu.restaurantId,
    };
    this.relanceMailManquant(recu);
  }

  public getCsvRecusTitle() {
    const start = moment(this.dateType.dateDebut).format("DD-MM-YYYY");
    const end = moment(this.dateType.dateFin).format("DD-MM-YYYY");
    let titre = this.$t("ComptageCaisse").toString();
    const site =
      this.selectedSites.length > 0
        ? this.selectedSites[0].libelle
        : this.$t("multiSites").toString();
    titre += `-${site}-${start}-${end}`;
    // console.log(titre);
    return titre;
  }

  public getManquants() {
    let index = 0;
    const today = moment().subtract(1, "d");
    // console.log(this.dateType);
    const days = this.getAllDaysPeriode(
      this.dateType.dateDebut ? this.dateType.dateDebut : new Date(),
      this.dateType.dateFin ? this.dateType.dateFin : new Date()
    );
    days.forEach((date: string) => {
      if (today.isBefore(date)) {
        // console.log(date, "isBefore", today.format("DD-MM"));
      } else {
        this.sites.forEach((site: Site) => {
          const found = this.recus.find((recu: any) => {
            return (
              recu.libSite === site.libelle &&
              date === moment(recu.dateFiscale).format("YYYY-MM-DD")
            );
          });
          if (!found) {
            const missRecu = new Recu();
            missRecu.makeMissing(
              date,
              site.libelle,
              site.restaurantId,
              index + 1
            );
            this.recus.push(missRecu);
            index++;
          }
        });
      }
    });
  }

  public getCsvRecuCaisse() {
    const list = this.recus;
    let recusJson = new Array();
    recusJson = list.map((recu: any) => {
      return this.transformRecuFeuilleCaisse(recu);
    });
    return recusJson;
  }
  /**
   * methode permettant d'avoir uniquement la partie filtrée des recus
   * @param recus
   */
  public recusFiltres(recus: any) {
    // console.log(recus);
  }

  private relanceMailRecu(recu: any) {
    this.$store.dispatch("analyses/relanceMail", recu).then(
      (response: any) => {
        // console.log(response);
        this.setSuccess(this.$t("MailEnvoye").toString());
      },
      (error: any) => {
        this.setErrorFromTxt(error, this.$t("ErreurEnvoiMail").toString());
      }
    );
  }

  private relanceMailManquant(recu: any) {
    this.$store.dispatch("analyses/relanceMailManquant", recu).then(
      (response: any) => {
        // console.log(response);
        this.setSuccess(this.$t("MailEnvoye").toString());
      },
      (error: any) => {
        this.setErrorFromTxt(error, this.$t("ErreurEnvoiMail").toString());
      }
    );
  }

  private orderData() {
    this.recus.map((comptage: any) => {
      // console.log(comptage);
      let reel = 0;
      let theo = 0;
      comptage.tiroirReglements.map((regl: any) => {
        // console.log(regl.totalReel, regl.totalTheorique)
        reel += regl.totalReel;
        theo += regl.totalTheorique;
        // console.log(reel, theo);
      });
      comptage.reel = reel;
      comptage.theo = theo;
      comptage.diff = reel - theo;
      comptage.district = ""; // coment faire ?
      comptage.isForced = false;
      comptage.commentaire = "";
      // console.log(reel, theo, comptage.diff);
      switch (comptage.type) {
        case "RECU_FIN_SESSION_DECLARE":
          comptage.etat = "Cloturé";
          comptage.order = 2;
          break;
        case "RECU_FIN_SESSION_ATTENTE_CONTRE_SIGNATURE":
          comptage.etat = "En attente";
          comptage.order = 0;
          break;
        case "RECU_FIN_SESSION_CONTRE_SIGNE":
          comptage.etat = "Validé";
          comptage.order = 2;
          comptage.isForced = true;
          break;
        case "MISSING":
          comptage.etat = "Manquant";
          comptage.order = 1;
          break;
      }

      comptage.lastHorodatage = comptage.validationHorodatage; // new Date().getTime(); // voir dans les complements

      if (comptage.complements && comptage.complements.length > 0) {
        comptage.complements.map((complement: any) => {
          if (complement.cle.includes("CONTRE_SIGNATURE")) {
            comptage.etat = "Validé";
            comptage.isForced = true;
          }
          if (complement.cle.includes("CONTRE_SIGNATURE_HORODATAGE")) {
            comptage.lastHorodatage = complement.valeur;
          }
          if (complement.cle.includes("VALIDATION_HORODATAGE_INITIAL")) {
            comptage.horodatage = complement.valeur;
          }
          if (complement.cle.includes("RELANCE_HORODATAGE")) {
            comptage.horodatageRelance = complement.valeur;
          }
          if (complement.cle.includes("RELANCE_UTILISATEUR")) {
            comptage.utilisateurRelance = complement.valeur;
          }
        });
      }
    });
    this.loadData = false;
    // console.log(this.recus);
  }

  private makeResume() {
    let mesRecus = this.recus;
    if (this.site !== "") {
      mesRecus = mesRecus.filter((recu: any) => recu.libSite === this.site);
    }
    this.resumeData = {
      manquants: { nombre: 0, montant: 0 },
      valides: { nombre: 0, montant: 0 },
      enAttente: { nombre: 0, montant: 0 },
      clotures: { nombre: 0, montant: 0 },
      ecarts: { nombre: 0, montant: 0 },
    };
    mesRecus.map((recu: Recu) => {
      // console.log(recu.etat);
      switch (recu.etat) {
        case "Validé":
          this.resumeData.valides.nombre++;
          this.resumeData.valides.montant += recu.reel;
          break;
        case "En attente":
          // console.log("je suis la ");
          this.resumeData.enAttente.nombre++;
          this.resumeData.enAttente.montant += recu.reel;
          break;
        case "Manquant":
          this.resumeData.manquants.nombre++;
          this.resumeData.manquants.montant += recu.reel;
          break;
        case "Cloturé":
          this.resumeData.clotures.nombre++;
          this.resumeData.clotures.montant += recu.reel;
          break;
      }
      if (recu.diff !== 0) {
        this.resumeData.ecarts.nombre++;
        this.resumeData.ecarts.montant += recu.diff;
      }
    });
    // console.log("la", this.resumeData);
  }

  private transformRecuFeuilleCaisse(recu: any) {
    const obj: { [k: string]: any } = {
      dateFiscale: this.formatDateTicket(recu.dateFiscale),
      dateValidation: this.formatDateTicketHour(recu.validationHorodatage),
      etat: recu.etat,
      nomManager: recu.validationResponsable,
      manager: recu.validationResponsableCode,
      theorique: recu.theo,
      reel: recu.reel,
      ecart: recu.diff,
      restaurantId: recu.restaurantId,
      site: recu.libSite,
      commentaire: recu.commentaire,
      id: recu.id,
    };
    return obj;
  }

  get sites(): any {
    return this.$store.getters["login/sites"];
  }
  get client(): string {
    return this.$store.getters["getClient"];
  }

  get me(): any {
    return this.$store.getters["login/user"];
  }
}
